import fetchCustom from '@helpers/fetchCustom';

export const RECRUITMENT_AUTOMATIONS_EDITOR = 'recruitment_automations_editor';

export const fetchPositionRecruitmentAutomationsEditor = async (jobId, options = {}) => {
    const params = new URLSearchParams();
    params.append('expand', RECRUITMENT_AUTOMATIONS_EDITOR);
    const { signal, ...fetchOptions } = options;
    return fetchCustom(`/api/jobs/${jobId}/ui?${params.toString()}`, {
        method: 'GET',
        signal,
        ...fetchOptions,
    });
};
